import type { JSX } from "react";

import { Route, Routes } from "react-router-dom";
import LoadThread from "./LoadThread";
import PreviousThreads from "./PreviousThreads";
import SelectPersonality from "./SelectPersonality";

function ThreadRoutes(): JSX.Element {
    return (
        <Routes>
            <Route index element={<SelectPersonality />} />
            <Route path=":threadId" element={<LoadThread />} />
            <Route path="previous" element={<PreviousThreads />} />
        </Routes>
    );
}

export default ThreadRoutes;
